/**
 *  @class
 *  @function ContentGrid
 */
if (!customElements.get('content-grid')) {
    class ContentGrid extends HTMLElement {
        static get observedAttributes() {
            return ['selected-index'];
        }
        constructor() {
            super();
        }

        connectedCallback() {
            this.selectedIndex = this.selectedIndex;
            this.buttons = Array.from(this.querySelectorAll('.content-grid__tabs a'));
            this.panels = Array.from(this.querySelectorAll('.content-grid__inner_tab'));
            this.buttons.forEach((button, index) => {
                button.addEventListener('click', () => {
                    this.selectedIndex = index;
                });
            });
            if (Shopify.designMode) {
                this.addEventListener('shopify:block:select', (event) => {
                    this.selectedIndex = this.buttons.indexOf(event.target);
                });
            }
        }
        get selectedIndex() {
            return parseInt(this.getAttribute('selected-index')) || 0;
        }
        set selectedIndex(index) {
            this.setAttribute('selected-index', index);
        }
        attributeChangedCallback(name, oldValue, newValue) {
            if (name === "selected-index" && oldValue !== null && oldValue !== newValue) {
                this.buttons[oldValue].classList.remove('active');
                this.buttons[newValue].classList.add('active');
                this.panels[parseInt(oldValue)].classList.remove('active');
                this.panels[parseInt(newValue)].classList.add('active');
                if (typeof Flickity == "function") {
                    // Resize sliders within the tabs content
                    this.panels[parseInt(newValue)].querySelectorAll("slide-show.flickity-enabled").forEach((flickityElement) => {
                        Flickity(flickityElement).resize();
                    });
                }
            }
        }
    }
    customElements.define('content-grid', ContentGrid);
}
